  import React, { useState, useEffect } from 'react';
  import styled from 'styled-components';
  import ProfileModal from '../Components/Profile';
  import SidebarAdmin from '../Admin/SidebarAdmin'; 
  import NavbarAdmin from '../Admin/NavbarAdmin'; 
  import HomeAdmin from '../Admin/HomeAdmin'; 
  import AboutAdmin from '../Admin/AboutAdmin';
  import HelpAdmin from '../Admin/HelpAdmin';
  import ManagementAdmin from '../Admin/ManagementAdmin';
  
  import IAProfileAdd from '../Admin/iaProfilingAdd';
  import IAProfileEdit from '../Admin/iaProfilingEdit';
  import IAOfficers from '../Admin/iaOfficers';
  import IAOfficersFormAdd from '../Admin/iaOfficersFormAdd';
  import IAOfficersFormEdit from '../Admin/iaOfficersFormEdit';
  import IATraining from '../Admin/iaTraining';
  import ImtContract from '../Admin/imtContract';

  import RsbaMasterlist from '../Admin/rsbaMasterlist';
  import FBmasterlist from '../Admin/fbMasterlist';
  import Year from '../Admin/Year';
  import Machineries from '../Admin/Machineries';
  import PFS from '../Admin/PFS';
  import NIS from '../Admin/nis';
  import NISmachineries from '../Admin/NisMachineries';
  import NISmasterlist from '../Admin/nisMasterlist';
  
  import NISfsResult from '../Admin/NisFsResult';
  import NISofficers from '../Admin/NisOfficers';
  import NISimtResult from '../Admin/NisImtResult';
  import CIS from '../Admin/cis';
  import Convergence from '../Admin/convergence';
  import ConvergenceTemplate from '../Admin/convergenceTemplate';
  import Template from '../Admin/template';



  const DashboardAdmin = ({ darkMode, toggleDarkMode }) => {
    const [selectedContent, setSelectedContent] = useState('HomeAdmin');
    const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
    const [showFormAdd, setShowFormAdd] = useState(false);
    const [showFormEdit, setShowFormEdit] = useState(false); 
    const [selectedNisId, setSelectedNisId] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);



  const handleSelect = (nisId, iaName) => {
    console.log('Navigating to NISmasterlist with ID:', nisId);
    setSelectedNisId(nisId);
  };

    const handleNavClick = (item, options = {}) => {
      console.log(`Navigating to: ${item}`, options);

   if (['NISmachineries', 'NISmasterlist', 'NISfsResult', 'NISmachineries', 'NISimtResult', 'NISofficers'].includes(item)) {
    setSelectedNisId(options.nisId || null);
    setSelectedRow(options.row || null);
    setSelectedYear(options.year || null); // store the year
  }


      if (item === 'IAOfficersFormAdd' && selectedContent === 'IAOfficers') {
        setShowFormAdd(true); // Show add form alongside IAOfficers
      } else if (item === 'IAOfficersFormEdit' && selectedContent === 'IAOfficers') {
        setShowFormEdit(true); // Show edit form alongside IAOfficers
      } else if (item === 'IAOfficers' && options.closeForm) {
        setShowFormAdd(false); // Close add form when navigating back
        setShowFormEdit(false); // Close edit form when navigating back
        setSelectedContent('IAOfficers');
      } else {
        setSelectedContent(item);
        setShowFormAdd(false); // Reset add form visibility for other pages
        setShowFormEdit(false); // Reset edit form visibility for other pages
      }
    };

  const handleBackToNisOrCisMenu = () => {
    const pendingCisReturn = localStorage.getItem('cisMachineriesReturn');
    if (pendingCisReturn) {
      handleNavClick('CIS');
      return;
    }
    handleNavClick('NIS');
  };

  useEffect(() => {
      const requestedContent = localStorage.getItem('dashboardAdminInitialContent');
      if (requestedContent) {
        setSelectedContent(requestedContent);
        localStorage.removeItem('dashboardAdminInitialContent');
      }

      const handleCustomNavigation = (e) => {
        handleNavClick(e.detail.item, e.detail.options || {});
      };

      window.addEventListener('navigateTo', handleCustomNavigation);

      return () => {
        window.removeEventListener('navigateTo', handleCustomNavigation);
      };
    }, []);
  

    const handleSidebarToggle = (expanded) => {
      setIsSidebarExpanded(expanded);
    };

    const renderContent = () => {
      switch (selectedContent) {
        case 'HomeAdmin': 
          return <HomeAdmin darkMode={darkMode} toggleDarkMode={toggleDarkMode} isSidebarExpanded={isSidebarExpanded}/>;
          
        case 'AboutAdmin':
          return <AboutAdmin />;

        case 'HelpAdmin':
          return <HelpAdmin />;

        case 'ManagementAdmin':
          return <ManagementAdmin isSidebarExpanded={isSidebarExpanded} />;


        case 'IAProfileAdd':
          return <IAProfileAdd darkMode={darkMode} toggleDarkMode={toggleDarkMode}/>;

        case 'IAProfileEdit':
          return <IAProfileEdit  darkMode={darkMode} toggleDarkMode={toggleDarkMode}/>;
        
        case 'IAOfficers':
          return (
            <SplitContainer>
              <IAOfficers
                darkMode={darkMode}
                toggleDarkMode={toggleDarkMode}
                onSelect={handleNavClick}
                showFormAdd={showFormAdd}
                showFormEdit={showFormEdit}
                onBack={handleBackToNisOrCisMenu} // Pass showFormEdit prop
              />
              {(showFormAdd || showFormEdit) && (
                <FormWrapper>
                  {showFormAdd && (
                    <IAOfficersFormAdd
                      darkMode={darkMode}
                      toggleDarkMode={toggleDarkMode}
                      onSelect={handleNavClick}
                    />
                  )}
                  {showFormEdit && (
                    <IAOfficersFormEdit
                      darkMode={darkMode}
                      toggleDarkMode={toggleDarkMode}
                      onSelect={handleNavClick}
                    />
                  )}
                </FormWrapper>
              )}
            </SplitContainer>
          );
        case 'IATraining':
          return <IATraining darkMode={darkMode} toggleDarkMode={toggleDarkMode}/>;

        case 'ImtContract':
          return <ImtContract darkMode={darkMode} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} onBack={handleBackToNisOrCisMenu} />;

        case 'NISimtResult':
          return ( <NISimtResult darkMode={darkMode} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} nisId={selectedNisId} iaName={selectedRow?.ia_name} year={selectedYear || new Date().getFullYear()} onBack={handleBackToNisOrCisMenu}/>);

        case 'RsbaMasterlist':
            return <RsbaMasterlist darkMode={darkMode} toggleDarkMode={toggleDarkMode} />;

        case 'FBmasterlist':
          return <FBmasterlist darkMode={darkMode} toggleDarkMode={toggleDarkMode}  setShowimtContract={handleBackToNisOrCisMenu}/>;

        case 'Year':
            return <Year darkMode={darkMode} toggleDarkMode={toggleDarkMode}  onSelect={handleNavClick} />;

        case 'Machineries':
          return <Machineries darkMode={darkMode} toggleDarkMode={toggleDarkMode}  onBack={handleBackToNisOrCisMenu}/>;

        case 'PFS':
          return <PFS onBack={handleBackToNisOrCisMenu} />;

        case 'NIS':
          return (
            <NIS
              darkMode={darkMode}
              toggleDarkMode={toggleDarkMode}
              onSelect={handleNavClick}
              isSidebarExpanded={isSidebarExpanded}
            />
          );

        case 'NISmasterlist':
          return ( <NISmasterlist darkMode={darkMode} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} nisId={selectedNisId}iaName={selectedRow?.ia_name} year={selectedYear || new Date().getFullYear()} onBack={handleBackToNisOrCisMenu}/>);

        case 'NISmachineries':
            return ( <NISmachineries darkMode={darkMode} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} nisId={selectedNisId} iaName={selectedRow?.ia_name} year={selectedYear || new Date().getFullYear()} onBack={handleBackToNisOrCisMenu}/>);

        case 'NISfsResult':
            return ( <NISfsResult darkMode={darkMode} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} nisId={selectedNisId} iaName={selectedRow?.ia_name}  year={selectedYear || new Date().getFullYear()} onBack={handleBackToNisOrCisMenu}/>);
        
        case 'NISofficers':
            return ( <NISofficers darkMode={darkMode} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} nisId={selectedNisId} iaName={selectedRow?.ia_name} year={selectedYear || new Date().getFullYear()} onBack={handleBackToNisOrCisMenu}/>);

        case 'CIS':
          return ( <CIS isSidebarExpanded={isSidebarExpanded} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} />);

        case 'Convergence':
          return ( <Convergence isSidebarExpanded={isSidebarExpanded} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} onBack={handleBackToNisOrCisMenu} />);

        case 'ConvergenceTemplate':
          return ( <ConvergenceTemplate isSidebarExpanded={isSidebarExpanded} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} />);

        case 'Template':
          return ( <Template darkMode={darkMode} toggleDarkMode={toggleDarkMode} onSelect={handleNavClick} />);


        case 'ProfileModal':
          return <ProfileModal />;

        default:
        return <HomeAdmin />;
      }
    };

    return (
      <DashboardContainer> 
        <NavbarAdmin onSelect={handleNavClick} darkMode={darkMode} toggleDarkMode={toggleDarkMode} isSidebarExpanded={isSidebarExpanded} />
        <SidebarAdmin
          isExpanded={isSidebarExpanded}
          lockFixed={selectedContent === 'NISmachineries'}
          onSelect={handleNavClick}
          selectedContent={selectedContent}
          onToggleSidebar={handleSidebarToggle}
          darkMode={darkMode} toggleDarkMode={toggleDarkMode}
        />
        <Content
          isExpanded={isSidebarExpanded}
          isHelpView={selectedContent === 'HelpAdmin'}
        >
          {renderContent()}
        </Content>
      </DashboardContainer>
    );
  };

  export default DashboardAdmin;

  const DashboardContainer = styled.div`
    display: flex;
    height: 100vh;
    width: 100%;
    position: relative; 
    overflow: hidden;
  `;

  const Content = styled.div`
    flex-grow: 1;
    margin-left: ${({ isExpanded, isHelpView }) => {
      if (isHelpView) {
        return isExpanded ? '18px' : '18px';
      }
      return isExpanded ? '6px' : '4px';
    }};
    transition: margin-left 0.2s ease;
    padding: ${({ isHelpView }) => (isHelpView ? '2px' : '2px')};
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }
  `;

  const SplitContainer = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
    gap: 20px;
  `;

  const FormWrapper = styled.div`
    flex: 1;
    max-width: 46.2%;
    overflow: auto;
    background-color: ${props => (props.darkMode ? '#1a1a1a' : '#ffffff')};
    padding: 10px  /* Added padding-right: 20px */
    border-left: 20px solid #ccc;
    margin-top: 20px;
  `;

